import React, { Component } from 'react'
import ModalForm from '../../comum/components/ModalForm'
import { inject, observer } from 'mobx-react'
import moment from 'moment'


@inject("store")
@observer
export default class ModalObsFluxo extends Component {
    constructor(props){
        super(props)

        this.controller = this.props.controller

    }

    handleEditar = () => {
        this.controller.alternarModalEditar(this.controller.modalObsFluxo)
        this.controller.fecharObsFluxo()
    }

    render() {
        return (
            <ModalForm
                className="modal-obs"
                labelConfirmar={ 
                    this.controller.modalObsSituacao 
                    && (this.controller.editaveis.includes(this.controller.modalObsSituacao))
                    ? "EDITAR"
                    : <span />
                }
                labelCancelar="FECHAR"
                onClickSalvar={ 
                    this.controller.modalObsSituacao 
                    && (this.controller.editaveis.includes(this.controller.modalObsSituacao))
                    ? this.handleEditar
                    : null
                }
                onClickCancelar={ () => this.controller.fecharObsFluxo() }
            >
                <h2>Observações do Tecon</h2>
                <div className="observacoes">
                    {this.controller.modalObsAnalise && this.controller.modalObsAnalise.map(obs => {
                        return(
                            <div className="mb-4" key={obs.Id}>
                                <h4 className="data">
                                    { moment(obs.DtIncl).format("DD MMM, YY") }
                                    <span className="ml-2 hora">
                                        ({ moment(obs.DtIncl).format("HH:mm:ss") })
                                    </span>
                                </h4>
                                <div className="texto">
                                    { obs.Obs }
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="total-obs">{this.controller.modalObsAnalise.length} Observações</div>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/analise/components/ModalObsFluxo.js